export const PHONE_THUMBNAILS_LIMIT = 2
export const DEFAULT_THUMBNAILS_LIMIT = 3

export enum BundleShippingType {
  Integrated = 'integrated',
  CustomOrNoShipping = 'custom_or_no_shipping',
  ShippingUnavailable = 'shipping_unavailable',
}

export enum ItemThumbnailSize {
  Small = 'thumb70x100',
  Medium = 'thumb150x210',
  Large = 'thumb310x430',
  XLarge = 'thumb364x428',
  X2Large = 'thumb624x428',
}

export enum BundlingLimitationsErrorType {
  ItemExceedsLimit = 'item_exceeds_limit',
  BundleExceedsLimit = 'bundle_exceeds_limit',
}
